export default __webpack_public_path__ + "static/media/logo_small.8cb75e42.png";